document.addEventListener('click', (event) => {
  const swatch = event.target.closest('[data-sq-swatch]');
  if (swatch && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
    const card = swatch.closest('.product-card-wrapper');
    const photo = card?.querySelector('.card__media img, .sq-media img');
    if (card && photo && swatch.dataset.image) {
      event.preventDefault();
      photo.src = swatch.dataset.image;
      photo.srcset = swatch.dataset.image + ' 900w';
      photo.alt = swatch.getAttribute('aria-label');
      card.classList.add('sq-color-chosen');
      card.querySelectorAll('[data-sq-swatch]').forEach((item) => {
        item.classList.toggle('is-selected', item === swatch);
        if (item === swatch) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
      card.querySelectorAll('a.full-unstyled-link, a.sq-studio-product-link').forEach((link) => { link.href = swatch.href; });
      let label = card.querySelector('.sq-card-color-name');
      if (!label) {
        label = document.createElement('span');
        label.className = 'sq-card-color-name';
        label.setAttribute('aria-live', 'polite');
        swatch.parentElement.after(label);
      }
      label.textContent = swatch.dataset.color;
    }
  }
  const opener = event.target.closest('[data-sq-guide-open]');
  const dialog = document.getElementById('sq-size-dialog');
  if (opener && dialog) {
    const source = document.getElementById('sq-size-guide');
    if (!source) return;
    const guide = source.cloneNode(true);
    guide.removeAttribute('id');
    guide.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
    dialog.querySelector('[data-sq-guide-content]').replaceChildren(guide);
    dialog.showModal();
  }
  if (event.target.closest('[data-sq-guide-close]') && dialog) dialog.close();
  if (event.target === dialog) {
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  }
});

function sqPrepareCollectionRails(root = document) {
  root.querySelectorAll('[data-sq-rail-controls]').forEach((controls) => {
    if (controls.dataset.sqReady) return;
    const rail = document.getElementById(controls.dataset.sqRailControls);
    if (!rail) return;
    controls.dataset.sqReady = 'true';
    const previous = controls.querySelector('[data-sq-rail-prev]');
    const next = controls.querySelector('[data-sq-rail-next]');
    const refresh = () => {
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };
    const move = (direction) => {
      const item = rail.firstElementChild;
      const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : rail.clientWidth;
      const count = Math.max(1, Math.floor(rail.clientWidth / step));
      rail.scrollBy({left:direction * step * count,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', refresh, {passive:true});
    new ResizeObserver(refresh).observe(rail);
    refresh();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sqPrepareCollectionRails());
else sqPrepareCollectionRails();
document.addEventListener('shopify:section:load', (event) => sqPrepareCollectionRails(event.target));
